import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import useH2HConceptChartData from '../../hooks/useH2HConceptChartData';
import VerticalBars from '../../../../../../../components/charts/chartjs/vertical-bars/VerticalBars';
import VerticalBarTooltipLabels from '../../../../../../../components/charts/chartjs/vertical-bars/vertical-bar-tooltip-labels/VerticalBarTooltipLabels';

import scss from './ChartsH2H.module.scss';

function SingleChartH2H({ h2hConcept, isGlobalPercentage }) {
  const conceptsH2H = useSelector((state) => state.resonance.conceptsH2H);

  const selectedH2HConcept = useMemo(
    () => conceptsH2H.find((concept) => concept.id === h2hConcept.value),
    [conceptsH2H, h2hConcept],
  );

  const { chartLabels, datasets, chartsConfig } = useH2HConceptChartData(selectedH2HConcept, isGlobalPercentage);

  return (
    <div className={scss.chartWrapper}>
      <VerticalBars
        height={'300px'}
        data={{
          labels: chartLabels,
          datasets: datasets,
        }}
        config={chartsConfig}
      />
      <VerticalBarTooltipLabels labels={chartLabels} />
    </div>
  );
}

export default SingleChartH2H;
